<div class="profile-page {{ this.profile.bgBody }}">
  <div class="container">
    <div class="profile-page__header">
      <div id="map-profile" class="map" [class.title-placeholder]="loading"></div>
      <div class="body">
        <div class="img-with-chart" [class.active]="chartPopup">
          <img loading="lazy" class="profile-img" (click)="chartPopup = !chartPopup" [class.title-placeholder]="loading"
            src="{{ local.checkImageProfile(profile) }}" alt="" />
          <div class="my-chart">
            <canvas baseChart [data]="radarChartData" [options]="radarChartOptions" [type]="radarChartType"> </canvas>
          </div>
        </div>
        <div class="name" [class.title-placeholder]="loading">
          <span class="mr-2">{{ profile?.profileCharacterName?.substr(0, 12) ?? "Loading" }}</span>
          <span class="badge" *ngFor="let item of profile?.certified">
            {{ item }}
          </span>
        </div>
        <div class="meta">
          <span class="item"> <i class="fa-regular fa-clock"></i>Since {{ profile.created }} </span>
          <span class="item"> <i class="fa-regular fa-square-plus"></i>{{ profile.appUserSupports.length }} Support
          </span>
          <span class="item" *ngIf="profile?.regionName"> <i class="fa-solid fa-earth-asia"></i>{{ profile.regionName }}
          </span>
        </div>
        <div class="about">
          {{ profile.shortDescription }}
        </div>
        <!-- <div class="back" (click)="goBack()">
          <i class="fa fa-caret-left back-btn"></i>
          Back
        </div> -->
        <div class="back-button-section">
          <button class="back-button" (click)="goBack()"><i class="fa fa-arrow-left" aria-hidden="true"></i>
            Back</button>
        </div>
        <div class="bottom">
          <div class="certificates">
            @if(profile?.certificates.length){
            <div class="certificates__title">Badge</div>
            <ng-container *ngFor="let role of profile?.certificates">
              <img loading="lazy" src="{{ certificateImgUrl }}{{ role.role }}.png" alt="" />
            </ng-container>
            }
          </div>
          <div class="right">
            <button class="button-2 mr-2" routerLink="/advanced-settings" *ngIf="appUserId == profile.id">
              <i class="fas fa-gear"></i>
            </button>
            <button class="button-2 mr-2" (click)="shareMyProfile(SharePopup)">
              <i class="fa-solid fa fa-share-alt"></i>
            </button>
            <button class="button-2 mr-2" [class.active]="profile.isSupport" (click)="handleSupportSeller()"><i
                class="fa-solid fa-plus"></i> Friend</button>
            <span class="icon-list" aria-hidden="true" id="profileMenu" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false" *ngIf="isLogin">
              <i class="fa-solid fa-ellipsis-v"></i>
            </span>
            <div class="dropdown-menu" aria-labelledby="profileMenu">
              <a class="dropdown-item" *ngIf="this.appUserId == profile.id" (click)="setProfileToDefault()"><i
                  class="fa-solid fa-user-check"></i> Set Profile to Default</a>
              <a class="dropdown-item" *ngIf="this.appUserId == profile.id" (click)="setProfileToAvatar()"><i
                  class="fa-solid fa-user-check"></i> Set Profile to Avatar</a>
              <a class="dropdown-item"
                *ngIf="roleService?.roles?.users?.includes('COMMUNITY_PROFILE_MUTE') && this.appUserId != profile.id"
                (click)="muteProfile()"><i class="fa-solid fa-volume-mute"></i> {{ profile.isMuted ? "Unmute" : "Mute"
                }}</a>
              <a class="dropdown-item"
                *ngIf="roleService?.roles?.users?.includes('COMMUNITY_PROFILE_BLOCK') && this.appUserId != profile.id"
                (click)="blockProfile()"><i class="fa-solid fa-ban"></i> {{ profile.isBlocked ? "Unblock" : "Block"
                }}</a>
              <!-- <a class="dropdown-item" (click)="shareMyProfile(SharePopup)"><i class="fa-solid fa fa-share-alt"></i> Share</a> -->
              <!-- <a class="dropdown-item" routerLink="/advanced-settings" *ngIf="appUserId == profile.id"><i class="fas fa-gear"></i> Setting</a> -->
              <a class="dropdown-item" *ngIf="this.appUserId != profile.id" (click)="handleChatNow()"><i
                  class="fa-solid fa-comment-dots"></i> Chat Now</a>
            </div>
          </div>
        </div>
        <div class="certificates-mobile">
          @if(profile?.certificates.length){
          <div class="certificates__title">Badge</div>
          <ng-container *ngFor="let role of profile?.certificates">
            <img loading="lazy" src="{{ certificateImgUrl }}{{ role.role }}.png" alt="" />
          </ng-container>
          }
        </div>
      </div>
    </div>
    <div class="profile-page__product">
      <app-my-tabs [tabs]="tabs" [defaultTabIndex]="selMenu" (tabChange)="updateSelMenu($event)">
        <div allTab>
          <div class="products">
            @if(!loadingProduct){ @if(selMenu == 0) {

            <common-product-card-view (view)="viewProductDetails($event)"
              *ngFor="let i of productAllProductListFavorites" [list]="i"
              [isCommunityProduct]="true"></common-product-card-view>
            } @else {

            <common-product-card-view (view)="viewProductDetails($event)"
              *ngFor="let i of productAllProductListFiltered | filterBy : filterProp : filterValue" [list]="i"
              [isCommunityProduct]="true"></common-product-card-view>
            } } @else {
            <div class="card-skeleton">
              <div class="image-placeholder"></div>
              <div class="content-placeholder">
                <div class="title-placeholder"></div>
                <div class="desc-placeholder"></div>
              </div>
            </div>
            <div class="card-skeleton">
              <div class="image-placeholder"></div>
              <div class="content-placeholder">
                <div class="title-placeholder"></div>
                <div class="desc-placeholder"></div>
              </div>
            </div>
            <div class="card-skeleton">
              <div class="image-placeholder"></div>
              <div class="content-placeholder">
                <div class="title-placeholder"></div>
                <div class="desc-placeholder"></div>
              </div>
            </div>
            <div class="card-skeleton">
              <div class="image-placeholder"></div>
              <div class="content-placeholder">
                <div class="title-placeholder"></div>
                <div class="desc-placeholder"></div>
              </div>
            </div>
            <div class="card-skeleton">
              <div class="image-placeholder"></div>
              <div class="content-placeholder">
                <div class="title-placeholder"></div>
                <div class="desc-placeholder"></div>
              </div>
            </div>
            }
          </div>
        </div>
      </app-my-tabs>
    </div>

    <div class="profile-page__product mt-3">
      <app-my-tabs [tabs]="tabs2" [defaultTabIndex]="selMenu2" (tabChange)="selectMenu2($event)">
        <div tab0>
          <div class="px-3">
            <app-my-carousel-swiper [config]="carouselOptionsSupported">
              @for(item of supported; track item){
              <div class="swiper-slide">
                <a class="card-page" (click)="navigateToShop(item)">
                  <div class="image">
                    @if(item.sellerImage){
                    <img loading="lazy" [src]="imgUrl + item.sellerImage" [alt]="item.sellerName" />
                    }@else {
                    <img loading="lazy" src="../../../../assets/images/shop/default.png" alt="" />
                    }
                  </div>
                  <div class="card-page__body">
                    <div class="card-page__body--cate">{{ item.category | uppercase }}</div>
                    <div class="card-page__body--name">{{ item.sellerName }}</div>
                  </div>
                </a>
              </div>
              }@empty {
              <div class="no-product">
                <div class="no-product__title">You Have Not Supported Anyone</div>
              </div>
              }
            </app-my-carousel-swiper>
          </div>
        </div>
        <div class="gallery px-3" tab1>
          @if(userExperiences?.data?.length > 0) {
          <div class="gallery__body-2">
            <div style="position: relative" *ngFor="let file of userExperiences.data; let i = index">
              <ng-container *ngIf="file.image.endsWith('.mp4'); else imageTemplate">
                <video class="rounded" (click)="openShowImageModal(ShowImageModal, file)" [src]="imgUrl + file.file"
                  controls style="width: 100%; height: fit-content"></video>
              </ng-container>
              <ng-template #imageTemplate>
                <img loading="lazy" class="image" (click)="openShowImageModal(ShowImageModal, file)"
                  [src]="imgUrl + file.image" alt="" />
              </ng-template>
            </div>
          </div>
          }@else {
          <div class="not-found text-center mt-4">
            <i class="fa-solid fa-exclamation-circle fa-2x"></i>
            <div class="mt-2" style="font-size: 1.5rem">No Experience found</div>
          </div>
          }
        </div>
      </app-my-tabs>
    </div>
  </div>
</div>

<ng-template #loadedContent>
  <div class="profile-page">
    <div class="container">
      <div class="profile-page__header">
        <div id="map-profile" class="map"></div>
        <div class="body">
          <img loading="lazy" class="profile-img" src="{{ local.checkImageProfile(profile) }}" alt="" />
          <div class="name">
            {{ profile.profileCharacterName }}
            <div>
              <span class="badge" *ngFor="let item of profile?.certified">
                {{ item }}
              </span>
            </div>
          </div>
          <div class="meta">
            <span class="item"> <i class="fa-regular fa-clock"></i>Since {{ profile.created }} </span>
            <span class="item"> <i class="fa-regular fa-square-plus"></i>{{ profile.appUserSupports.length }} Support
            </span>
            <span class="item" *ngIf="profile?.region"> <i class="fa-solid fa-earth-asia"></i>{{
              profile.region.split("|")[1] }} </span>
          </div>
          <div class="about">
            {{ profile.shortDescription }}
          </div>
          <div class="back-button-section">
            <button class="back-button" (click)="goBack()"><i class="fa fa-arrow-left" aria-hidden="true"></i>
              Back</button>
          </div>
          <!-- <div class="back" (click)="goBack()">
            <i class="fa fa-caret-left back-btn"></i>
            Back
          </div> -->
          <div class="bottom">
            <div class="certificates">
              @if(profile?.certificates.length){
              <div class="certificates__title">Badge</div>
              <img loading="lazy" *ngFor="let role of profile?.certificates"
                src="{{ certificateImgUrl }}{{ role.role }}.png" alt="" />
              }
            </div>
            <div class="right">
              <button class="button-2 mr-2" [class.active]="profile.isSupport" (click)="handleSupportSeller()"><i
                  class="fa-solid fa-plus"></i> {{ profile.isSupport ? "Supported" : "Support" }}</button>
              <span class="icon-list" aria-hidden="true" id="profileMenu" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false" *ngIf="isLogin">
                <i class="fa-solid fa-ellipsis-v"></i>
              </span>
              <div class="dropdown-menu" aria-labelledby="profileMenu">
                <a class="dropdown-item" *ngIf="this.appUserId == profile.id" (click)="setProfileToDefault()"><i
                    class="fa-solid fa-user-check"></i> Set Profile to Default</a>
                <a class="dropdown-item" *ngIf="this.appUserId == profile.id" (click)="setProfileToAvatar()"><i
                    class="fa-solid fa-user-check"></i> Set Profile to Avatar</a>
                <a class="dropdown-item" *ngIf="roleService?.roles?.users?.includes('COMMUNITY_PROFILE_MUTE')"
                  (click)="muteProfile()"><i class="fa-solid fa-volume-mute"></i> {{ profile.isMuted ? "Unmute" : "Mute"
                  }}</a>
                <a class="dropdown-item" *ngIf="roleService?.roles?.users?.includes('COMMUNITY_PROFILE_BLOCK')"
                  (click)="blockProfile()"><i class="fa-solid fa-ban"></i> {{ profile.isBlocked ? "Unblock" : "Block"
                  }}</a>
                <a class="dropdown-item" (click)="shareMyProfile(SharePopup)"><i class="fa-solid fa fa-share-alt"></i>
                  Share</a>
                <a class="dropdown-item" (click)="handleChatNow()"><i class="fa-solid fa-comment-dots"></i> Chat Now</a>
              </div>
              <!-- <div ngbDropdown class="d-inline-block right">
                <span class="icon-list" id="dropdownMenuButton" ngbDropdownToggle>
                  <i class="fa-solid fa-ellipsis-v"></i>
                </span>
                <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                  <button class="dropdown-item" (click)="setProfileToDefault()"><i class="fa-solid fa-user-check"></i> Set Profile to Default</button>
                  <button class="dropdown-item" (click)="setProfileToAvatar()"><i class="fa-solid fa-user-check"></i> Set Profile to Avatar</button>
                  <button class="dropdown-item" (click)="muteProfile()"><i class="fa-solid fa-volume-mute"></i> {{ profile.isMuted ? "Unmute" : "Mute" }}</button>
                  <button class="dropdown-item" (click)="blockProfile()"><i class="fa-solid fa-ban"></i> {{ profile.isBlocked ? "Unblock" : "Block" }}</button>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="profile-page__product">
        <app-my-tabs [tabs]="tabs" [defaultTabIndex]="selMenu" (tabChange)="updateSelMenu($event)">
          <div allTab>
            <div class="search">
              <input type="text" (keyup)="filterProduct($event)" placeholder="Search for name or description..." />
              <i class="fa-solid fa-magnifying-glass"></i>
            </div>
            <div class="products">
              <common-product-card-view (view)="viewProductDetails($event)"
                *ngFor="let i of productAllProductListFiltered | filterBy : filterProp : filterValue" [list]="i"
                [isCommunityProduct]="true"></common-product-card-view>
            </div>
          </div>
        </app-my-tabs>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #loadedContent> </ng-template>

<app-marketplace #marketplace [share]="true"></app-marketplace>

<ng-template #SharePopup let-modal>
  <div class="modal-body referral-modal">
    <div class="add_cattt">
      <h2>Share</h2>
      <img loading="lazy" src="../../../assets/images/close-icon.svg" alt="img"
        (click)="modal.dismiss('Cross click')" />
    </div>

    <div class="referral-link">
      <h6>
        <span>Profile Link</span>
      </h6>
      <div
        style="display: flex; flex-direction: column; align-items: center; margin-bottom: 2rem; margin-top: -24px; word-wrap: break-word;">
        <a class="referral-title w-100 mt-2 mb-2" href="{{ refer_friend_link }}" target="_blank" style="width: 80%">
          <p class="ref_link">{{ refer_friend_link }}</p>
        </a>
        <section class="d-flex w-100 justify-content-center mt-4">
          <div class="">
            <a class="confirm_button mr-2" (click)="copyReferralLink()">
              <img loading="lazy" src="../../../../assets/images/copy-icon.svg" alt="img" />
              Copy</a>
          </div>
          <div class="">
            <a class="confirm_button" (click)="share(refer_friend_link)">
              <i class="fa fa-share"></i>
              Share</a>
          </div>
        </section>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ShowImageModal let-modal>
  <ng-container *ngIf="showImageGallery.image.endsWith('.mp4'); else imageTemplate">
    <video controls style="width: 100%; height: fit-content">
      <source [src]="imgUrl + showImageGallery.image" type="video/mp4" />
    </video>
  </ng-container>
  <ng-template #imageTemplate>
    <img loading="lazy" [src]="imgUrl + showImageGallery.image" alt="" />
  </ng-template>
  @if(showImageGallery.message) {
  <div class="desc">{{ showImageGallery.message }}</div>
  }
</ng-template>